import { QuestionAnswerDto, QuestionDto } from '@careapp-group/ng-sdk';
import { CAAction } from '../actions';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { Questions } from './questions.actions';

export interface QuestionsStateInterface extends DataListState<QuestionDto> {}

class QuestionsState extends ReducerStateFactory<QuestionDto> {
  readonly initialState: QuestionsStateInterface = {
    ...INITIAL_DATA_LIST_STATE,
  };

  constructor(actions) {
    super(actions);
  }

  public reducer(state = this.initialState, action: CAAction): QuestionsStateInterface {
    switch (action.type) {
      case Questions.REQUEST_ANSWER_QUESTION:
        return {
          ...state,
          loadingAll: true,
        } as QuestionsStateInterface;

      case Questions.RESPONSE_SUCCESS_ANSWER_QUESTION: {
        const typedPayload = action.payload as QuestionAnswerDto;
        const updatedQuestion = {
          ...state.entities[typedPayload.questionId],
          answer: typedPayload,
          // Used to display a question on the feed until the user refreshes the page.
          recentlyAnswered: true,
        };
        const newEntities = {
          ...state.entities,
          [typedPayload.questionId]: updatedQuestion,
        };
        return {
          ...state,
          entities: newEntities,
          ids: [...state.ids],
          loadingAll: false,
        } as QuestionsStateInterface;
      }
      case Questions.RESPONSE_FAIL_ANSWER_QUESTION:
        return {
          ...state,
          loadingAll: false,
          error: (action as any).payload,
        } as QuestionsStateInterface;
    }
    return <any>super.reducer(state, action);
  }
}

export const state = new QuestionsState(Questions);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
